import { ContactSupport, NavigateNext } from '@mui/icons-material';
import {
  Box,
  Breadcrumbs as BreadcrumbsMui,
  Divider,
  Typography,
  colors,
} from '@mui/material';
import { Button } from '~/components/Button';
import FeedbackButton from '~/components/FeedbackButton';
import { Link } from '~/components/Link';
import { useLiveChat } from '~/hooks/useLiveChat';
export interface Breadcrumb {
  text: string;
  disabled?: boolean;
  href: string;
}

interface BreadcrumbsProps {
  breadcrumbs?: Breadcrumb[];
  livechat?: boolean;
}
export const Breadcrumbs = ({ breadcrumbs, livechat }: BreadcrumbsProps) => {
  const { showChat, isChatEnabled } = useLiveChat();
  return (
    <>
      <Box sx={{ backgroundColor: colors.grey[50], px: 3 }}>
        <Divider />
        <Box
          display="flex"
          justifyContent="space-between"
          sx={{ marginTop: '2px' }}>
          <BreadcrumbsMui
            aria-label="breadcrumb"
            separator={<NavigateNext fontSize="small" />}
            sx={{ py: 1, marginX: 0, paddingX: 0 }}>
            {breadcrumbs?.map((breadcrumb, index) => {
              if (breadcrumb.disabled) {
                return (
                  <Typography
                    key={index}
                    color="text.secondary"
                    variant="body2"
                    style={{ marginBottom: 0 }}>
                    {breadcrumb.text}
                  </Typography>
                );
              }
              return (
                <Link
                  key={index}
                  variant="body2"
                  underline="hover"
                  href={breadcrumb.href}>
                  {breadcrumb.text}
                </Link>
              );
            })}
          </BreadcrumbsMui>
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            {livechat && isChatEnabled && (
              <Button
                color="secondary"
                variant="text"
                onClick={() => showChat()}
                sx={{ mr: 1 }}
                startIcon={<ContactSupport />}>
                Live Chat
              </Button>
            )}
            <FeedbackButton />
          </Box>
        </Box>
      </Box>
      <Divider />
    </>
  );
};
